import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Text from '../Text';

class TextLink extends Component {
  static propTypes = {
    children: PropTypes.string
  };

  static defaultProps = {
    children: 'Link Text Here'
  };

  render() {
    const { children } = this.props;

    return (
      <Text.H3 transform="uppercase" color="grey2">
        <Text.H3 tag="span" transform="uppercase" color="red" font="icon">{` `}</Text.H3>
        {children}
      </Text.H3>
    );
  }
}

export default TextLink;
